import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, shortUrl } from "@/lib/api";
import { PageHeader } from "@/components/dash/Ui";
import { DateFilter, DEFAULT_RANGE } from "@/components/dash/DateFilter";
import { StatsView } from "@/components/dash/StatsView";
import { RecentClicks } from "@/components/dash/RecentClicks";

export default function LinkDetail() {
  const { id } = useParams();
  const [link, setLink] = useState(null);
  const [range, setRange] = useState(DEFAULT_RANGE);
  const [gran, setGran] = useState("day");
  const [s, setS] = useState(null);

  useEffect(() => { api.get(`/links/${id}`).then((r) => setLink(r.data)); }, [id]);
  useEffect(() => {
    api.get("/stats", { params: { start: range.start, end: range.end, granularity: gran, link_id: id } }).then((r) => setS(r.data));
  }, [id, range, gran]);

  return (
    <div>
      <Link to="/dashboard/links" data-testid="back-to-links" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-6">
        <ArrowLeft className="w-4 h-4" /> All links
      </Link>
      <PageHeader eyebrow={link ? (link.mode === "multi" ? `Multi-agent · ${link.numbers.length} numbers` : "Single number") : ""} title={link?.title || "…"}>
        <DateFilter value={range} onChange={setRange} />
      </PageHeader>
      {link && (
        <button data-testid="detail-copy-link" onClick={() => { navigator.clipboard.writeText(shortUrl(link.slug)); toast.success("Copied"); }}
          className="-mt-6 mb-8 inline-flex items-center gap-2 font-mono text-emerald-400 hover:text-emerald-300">
          {shortUrl(link.slug)} <Copy className="w-4 h-4" />
        </button>
      )}
      <StatsView s={s} gran={gran} setGran={setGran} showLinks={false} />
      <RecentClicks range={range} linkId={id} limit={500} title="Clicks on this link" />
    </div>
  );
}
